import ServiceUtils from "../singleton/service-utils";
import GdprPolicy from "../singleton/gdpr-policy";
import EmailTemplate from "../singleton/email-template";
import EmailSettings from "../singleton/email-settings";
import Email from "../singleton/email";

export default {

    getEmissions: Email.getEmissions.bind(Email),

    getSubstitutions: ServiceUtils.getPathSubstitutions.bind(ServiceUtils),

    getUrlSubstitutions: Email.getUrlSubstitutions.bind(Email),

    getNumberSubstitutions: Email.getNumberSubstitutions.bind(Email),

    getDateSubstitutions: Email.getDateSubstitutions.bind(Email),

    send: Email.send.bind(Email),

    getTestAddress: Email.getTestAddress.bind(Email),

    Template: {

        getAll: EmailTemplate.getAll.bind(EmailTemplate),

        get: EmailTemplate.get.bind(EmailTemplate),

        load: EmailTemplate.load.bind(EmailTemplate),

        create: EmailTemplate.create.bind(EmailTemplate),

        update: EmailTemplate.update.bind(EmailTemplate),

        delete: EmailTemplate.delete.bind(EmailTemplate),

        clone: EmailTemplate.clone.bind(EmailTemplate),

        setOrder: EmailTemplate.setOrder.bind(EmailTemplate)

    },

    Settings: {

        getAll: EmailSettings.getAll.bind(EmailSettings),

        saveAll: EmailSettings.saveAll.bind(EmailSettings),

        Buttons: {

            getAll: EmailSettings.btnGetAll.bind(EmailSettings)

        },

        Signature: {

            getAll: EmailSettings.signGetAll.bind(EmailSettings),

            loadAll: EmailSettings.signLoadAll.bind(EmailSettings),

            create: EmailSettings.signCreate.bind(EmailSettings),

            update: EmailSettings.signUpdate.bind(EmailSettings),

            delete: EmailSettings.signDelete.bind(EmailSettings),

        },

        GdprPolicy: {

            set: GdprPolicy.set.bind(GdprPolicy),

            getAll: GdprPolicy.getAll.bind(GdprPolicy)

        }

    }

};